import React, {useEffect, useState, useMemo} from "react";
import {Table, ImageStamp, TextInput, SearchButton} from "components";
import {useHistory} from "react-router-dom";
import {userSharesAction} from "redux/actions";
import * as XLSX from "xlsx";
import {allLikeShareAction} from "redux/actions"; 
import {useDispatch, useSelector} from "react-redux";
import styles from "./styles.module.scss";

export default function ({setDetails}) {
    // Routers
    const id = useHistory().location.pathname.split("/")[3];

    // Redux
    const dispatch = useDispatch();

    const {customers, allShare, userRole} = useSelector(state => ({
        customers: state.customers?.users,
        allShare: state.allLikeShare,
        userRole: state.userRole?.filter(role => role.module === "Refer & Earn")
    }));

    // States
    const [tableRows, setTableRows] = useState();

    // Filter States
    const [userId, setuserId] = useState('');
    const [firstName, setfirstName] = useState('');
    const [lastName, setlastName] = useState('');
    const [contactInfo, setcontactInfo] = useState('');
    

    // Fetch Package Add On
    useEffect(() => {
        const {mobile, countrycode} = customers?.find(user => user?.userId == id) || {};
        if (userRole?.find(item => item.privilege === "Read")) {
            // dispatch(allLikeShareAction.get({countrycode, mobile}));
            dispatch(allLikeShareAction.get());
        }
    }, [dispatch]);

    useEffect(() => {
        var filtered = allShare;
        if(userId != ''){
            filtered = allShare.filter((value)=>{
                if(value.user_id == userId){
                    return userRole?.find(item => item.privilege === "Read") ? value : null;
                }
            });
        }

        if(contactInfo != ''){
            filtered = allShare.filter((value)=>{
                if(value.contact_info == contactInfo){
                    return userRole?.find(item => item.privilege === "Read") ? value : null;
                }
            });
        }

        if(firstName != ''){
            filtered = allShare.filter((value)=>{
                if(value.get_user_details[0].first_name.toLowerCase() == firstName.toLowerCase()){
                    return userRole?.find(item => item.privilege === "Read") ? value : null;
                }
            });
        }

        if(lastName != ''){
            filtered = allShare.filter((value)=>{
                if(value.get_user_details[0].last_name.toLowerCase() == lastName.toLowerCase()){
                    return userRole?.find(item => item.privilege === "Read") ? value : null;
                }
            });
        }

        if (!filtered?.length) return;

        // filter based on Status
        //filtered = filtered?.filter();
        console.log(filtered);
        // Map table rows
        const data = filtered?.map(obj => ({
            user_id: obj?.user_id,
            mobile: obj?.get_user_details[0].mobile,
            email: obj?.get_user_details[0].email,
            first_name: obj?.get_user_details[0].first_name,
            last_name: obj?.get_user_details[0].last_name,
            shared_via: obj?.shared_via,
            receiver_name: obj?.receiver_name,
            contact_info: obj?.contact_info,
            created_at: `${new Date(obj.created_at).toLocaleString()}`
        }));
        
        setTableRows(data);
    }, [allShare,userId,contactInfo,firstName,lastName]);

    

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Customer",
                sortBy: "user_id"
            },
            {
                title: "Mobile",
                sortBy: "mobile"
            },
            {
                title: "Email",
                sortBy: "email"
            },
            {
                title: "First Name",
                sortBy: "first_name"
            },
            {
                title: "Last Name",
                sortBy: "last_name"
            },
            {
                title: "Shared Via",
                sortBy: "shared_via"
            },
            {
                title: "Receiver Name",
                sortBy: "receiver_name"
            },
            {
                title: "Receiver Mobile"
            },
            {
                title: "Created",
                sortBy: "created_at"
            }
        ],
        [tableRows]
    );
    

    const exportShareData = () => {
        const rows = tableRows.map(obj => {
            return {
                "Customer": obj?.user_id,
                "Shared Via": obj?.shared_via,
                "Receiver Name": obj?.receiver_name,
                "Receiver Mobile": obj?.contact_info,
                "User First Name": obj?.first_name,
                "User Last Name": obj?.last_name,
                "User Email": obj?.email,
                "User Mobile": obj?.mobile,
                "Created At": `${new Date(obj.created_at).toLocaleString()}`
            }
        })
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "ShareDatas.xlsx");
    }

    return (
        <div>
            <div className={styles.filter}>
                <TextInput
                    label="Customer"
                    placeholder="Customer"
                    name="user_id"
                    onChange={e => setuserId(e.target.value)}
                    value={userId}
                />

                <TextInput
                    label="First Name"
                    placeholder="First Name"
                    name="first_name"
                    onChange={e => setfirstName(e.target.value)}
                    value={firstName}
                />

                <TextInput
                    label="Last Name"
                    placeholder="Last Name"
                    name="last_name"
                    onChange={e => setlastName(e.target.value)}
                    value={lastName}
                />

                <TextInput
                    label="Receiver Mobile"
                    placeholder="Receiver Mobile"
                    name="contact_info"
                    onChange={e => setcontactInfo(e.target.value)}
                    value={contactInfo}
                />

                <button className={'btn btn-primary m-auto'} style={{margin: 10}} onClick={userRole?.find(item => item.privilege === "Read") ? exportShareData : null}> Export </button>
                
            </div>
            <Table headers={tableHeaders} data={tableRows} />
        </div>
    );
};
